import { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';
import { Icon, MenuItem, MenuList, Badge } from '@ff-it/ui';
import { useHasPerms } from 'core/permissions';
import income from 'modules/invoicing/income/permissions';
import expense from 'modules/invoicing/expenses/permissions';
import type { TaskList } from 'modules/tasks/types';

export function CampaignMenu({ inBlock, task_list }: { task_list: TaskList; inBlock?: boolean }): ReactElement {
  const [viewIncome, viewExpense] = useHasPerms(income.view, expense.view); // manage and change
  const prefix = inBlock ? '../' : ''; // relative to route
  return (
    <MenuList direction={inBlock ? 'vertical' : 'horizontal'} variant={inBlock ? 'light' : 'pills'}>
      <MenuItem to={`${prefix}planning`} label="Campaign" component={NavLink} prefix={<Icon icon="paper-plane" />} />
      <MenuItem
        prefix={<Icon icon="square-check" />}
        label="Tasks"
        component={NavLink}
        to={`${prefix}tasks`}
        suffix={task_list.opened ? <Badge count={task_list.opened} /> : null}
      />
      {viewIncome && (
        <MenuItem to={`${prefix}income`} label="Income" component={NavLink} prefix={<Icon icon="inbox-in" />} />
      )}
      {viewExpense && (
        <MenuItem to={`${prefix}expense`} label="Expense" component={NavLink} prefix={<Icon icon="inbox-out" />} />
      )}
      <MenuItem to={`${prefix}finance`} label="Finance" component={NavLink} prefix={<Icon icon="arrow-trend-up" />} />
      <MenuItem
        to={`${prefix}history`}
        label="History"
        component={NavLink}
        prefix={<Icon icon="clock-rotate-left" />}
      />
      <MenuItem to={`${prefix}update`} label="Edit campaign" component={NavLink} prefix={<Icon icon="marker" />} />
    </MenuList>
  );
}
